module.exports = __webpack_public_path__ + "static/media/wireframe2@2x.ec6462fd.png";